import { wait } from './wait';

export const randomWait = async (maxWait = 200, offsetMsec = 100) =>
  await wait(Math.random() * maxWait + offsetMsec);
